module.exports = __webpack_public_path__ + "static/media/sleep-badge.991423f4.svg";